/**
 * 채팅 상세(사용자매뉴얼 R06 5.2)에서 실패를 알리는 문구.
 *
 * 화면이 서버 사유를 그대로 띄우는 곳은 «4xx 이고 한국어인 사유» 만 쓴다. 영문 내부 문구·
 * 서버 오류(5xx)·연결 끊김은 매뉴얼에 적힌 일반 문구로 둔다. 공용 API 도우미는 응답을
 * `ApiError`(statusCode·userMessage) 로 바꿔 던지고, PDF 프록시(`downloadPdf`)는 axios 오류를
 * 그대로 던진다 — 둘 다 모양으로만 읽어 패키지 의존을 늘리지 않는다.
 */

/** 5.2.4 14번 — 파일 첨부가 실패한 경우(서버 메세지가 없을 때) */
export const FILE_ATTACH_FAILED_MESSAGE =
  "파일 첨부에 실패했습니다. 잠시 후 다시 시도해 주세요.";

/** 5.2.4.1 2번·5.2.4.4 1번 — 견적서·계약서 파일 정보를 받지 못함 */
export const PDF_INFO_MISSING_MESSAGE = "PDF 정보를 받아오지 못했습니다.";

/** 5.2.4.1 3번·5.2.4.4 2번 — 견적서·계약서 파일 처리 중 오류가 발생함 */
export const PDF_PROCESSING_FAILED_MESSAGE = "PDF 처리 중 오류가 발생했습니다.";

const read = (source: unknown, key: string): unknown =>
  typeof source === "object" && source !== null
    ? Reflect.get(source, key)
    : undefined;

/**
 * 서버가 준 4xx 한국어 사유가 있으면 그것을, 없으면 `fallback` 을 돌려준다.
 */
export function clientErrorMessage(error: unknown, fallback: string): string {
  const statusCode = read(error, "statusCode");
  const userMessage = read(error, "userMessage");
  if (
    typeof statusCode === "number" &&
    statusCode >= 400 &&
    statusCode < 500 &&
    typeof userMessage === "string" &&
    /[가-힣]/.test(userMessage)
  ) {
    return userMessage;
  }
  return fallback;
}

/**
 * PDF 내려받기 실패 문구.
 *
 * 서버가 응답은 했지만 파일을 주지 못했으면(오류 상태 코드) «PDF 정보를 받아오지 못했습니다.»,
 * 그 밖(연결 끊김·파일 저장 중 오류 등)은 «PDF 처리 중 오류가 발생했습니다.».
 */
export function pdfDownloadErrorMessage(error: unknown): string {
  const status =
    read(read(error, "response"), "status") ?? read(error, "statusCode");
  return typeof status === "number" && status > 0
    ? PDF_INFO_MISSING_MESSAGE
    : PDF_PROCESSING_FAILED_MESSAGE;
}
